﻿import $ from 'jquery'

declare global{
  interface JQuery {
    errorMessage(): JQuery;
  }
}

(function ($) {
  $.fn.errorMessage = function () {
    $(this).each(function () {
      var $this = $(this);
      var data = $this.data('rustig.errormessage');

      if (!data) {
        data = new ErrorMessage($(this));
        $this.data('rustig.errormessage', data);
      }
    });
    return $(this);
  };
})($);

export class ErrorMessage {
  constructor(public $element: JQuery) {
    $element.on('input', e => this.resetValidity(e));
    $element.on('invalid', e => this.handleInvalid(e));
  }
  private resetValidity(e: any): void {
    this.setValidity(e.target, '');
  }
  private handleInvalid(e: any): void {
    this.setValidity(e.target, this.$element.data('error-message'));
  }
  private setValidity($target: any, message: string = ''): void {
    $target.setCustomValidity(message);
  }
}
